import { z } from 'zod';
import { SyncTable } from './rows.js';

/** One local mutation, as queued in the client outbox and sent to POST /v1/sync. */
export const Change = z.object({
  table: SyncTable,
  rowId: z.string(),
  op: z.enum(['upsert', 'delete']),
  payload: z.record(z.string(), z.unknown()),
  updatedAt: z.string().min(13),
});
export type Change = z.infer<typeof Change>;

export const SyncRequest = z.object({
  deviceId: z.string().min(8),
  /** Last server sequence number this device has applied; 0 on first sync. */
  cursor: z.number().int().nonnegative(),
  changes: z.array(Change).max(500),
});
export type SyncRequest = z.infer<typeof SyncRequest>;

export const SyncResponse = z.object({
  changes: z.array(Change),
  cursor: z.number().int().nonnegative(),
  /** Server wall-clock ms, so clients can correct their offset for the live timer. */
  serverTime: z.number().int(),
});
export type SyncResponse = z.infer<typeof SyncResponse>;
